import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { PLATFORM_ENVIRONMENT } from '@platform-frontend/platform';
import { ShowErrorNotification, deepEqual, handleErrors } from '@platform-frontend/util';
import { Observable, switchMap } from 'rxjs';
import { MARKETPLACE_ERROR_HANDLERS } from '../../marketplace-error-handlers';
import { MSG_REGENERATE_SAAS_API_KEY_DEFAULT } from '../../notification-messages';
import { LicenseType } from '../../product';
import { AssetEssentials } from '../model/asset-essentials';
import { RegenerateSaasApiKeyModel } from './model/regenerate-saas-api-key-model';
import { SetSaasApiKey } from './saas-api-key.actions';

@Injectable({
  providedIn: 'root'
})
export class SaasApiKeyService {
  constructor(private http: HttpClient, private store: Store) {}

  updateAssetArray<T extends AssetEssentials>(assets: T[], licenseType: LicenseType, apiKey: string | null): T[] {
    const index = assets.findIndex(asset => asset.product.licenseTypes.length > 0 && deepEqual(licenseType, asset.product.licenseTypes[0]));
    if (index > -1) {
      const updatedAsset = { ...assets[index], apiKeys: [apiKey] };
      return [...assets.slice(0, index), updatedAsset, ...assets.slice(index + 1)];
    }
    return assets;
  }

  regenerateApiKey(licenseType: LicenseType, saasApiKey: string): Observable<unknown> {
    return this.http.post<RegenerateSaasApiKeyModel>(PLATFORM_ENVIRONMENT.apiUrl + '/saas-api/regenerate', { apiKey: saasApiKey }).pipe(
      handleErrors(MARKETPLACE_ERROR_HANDLERS, {
        DEFAULT: new ShowErrorNotification(MSG_REGENERATE_SAAS_API_KEY_DEFAULT)
      }),
      switchMap(regenerateSaasApiKey => this.store.dispatch(new SetSaasApiKey(licenseType, regenerateSaasApiKey.saasApiKey)))
    );
  }
}
